import { useIntl } from '@common/i18n';
import { AuthHandler } from '@common/uaa/utils/auth-handler';
import {
  Box,
  Button,
  Flex,
  Image,
  Input,
  Raio,
  Text,
} from '@common/ui-components';
import { useRouter } from 'next/router';
import { ChangeEvent, SyntheticEvent, useState } from 'react';

import { uaaIntlIds } from '../../intl';

export function QASignIn() {
  const { formatMessage } = useIntl();

  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
  });

  const router = useRouter();

  function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;

    setCredentials((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  async function handleSubmit(event: SyntheticEvent) {
    event.preventDefault();

    if (
      credentials.email === process.env.NEXT_PUBLIC_AUTOMATION_USER_EMAIL &&
      credentials.password === process.env.NEXT_PUBLIC_AUTOMATION_USER_PASSWORD
    ) {
      AuthHandler.setTokens(
        process.env.NEXT_PUBLIC_AUTOMATION_USER_TOKEN || '',
        'no-refresh-token'
      );

      router.push('/');

      return null;
    }
  }

  if (
    typeof window !== 'undefined' &&
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
  ) {
    router.replace('/404');

    return null;
  }

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      w="100vw"
      h="100vh"
      bg="gray.100"
    >
      <Flex
        direction="column"
        align="center"
        justify="center"
        gap={6}
        bg="white"
        borderRadius={8}
        zIndex={1}
        padding={10}
      >
        <Raio />

        <Text fontSize="lg" fontWeight="700" lineHeight={7}>
          {formatMessage({ id: uaaIntlIds.signIn.welcomeMessage })}
        </Text>

        <Text>
          {formatMessage({ id: uaaIntlIds.signIn.signInInstruction })}
        </Text>

        <Input
          type="email"
          name="email"
          placeholder={formatMessage({
            id: uaaIntlIds.signIn.qa.inputs.email.placeholder,
          })}
          onChange={handleInputChange}
        />

        <Input
          type="password"
          name="password"
          placeholder={formatMessage({
            id: uaaIntlIds.signIn.qa.inputs.password.placeholder,
          })}
          onChange={handleInputChange}
        />

        <Button onClick={handleSubmit}>
          {formatMessage({ id: uaaIntlIds.signIn.button.label })}
        </Button>
      </Flex>

      <Box position="fixed" bottom={12} right={8}>
        <Image
          src={'/images/man-riding-bike.svg'}
          alt={formatMessage({ id: uaaIntlIds.signIn.manRidingBikeAlt })}
          boxSize={{ base: '240px', lg: '240px', sm: '180px' }}
        />
      </Box>

      <Box
        position="fixed"
        w="calc(100vw - 32px)"
        bottom={8}
        right={0}
        borderTop="4px"
        borderLeftRadius={8}
        color="#1759FF"
      />
    </Flex>
  );
}
